import type { TimeRange } from "../../app/state/view/timeline/TimeRange";
import type { DashboardVariable } from "../../common/dashboard-spec";

import { type FormState, Processor } from "./_form-state";

export interface DrawerState {
	id?: string;
	mode: "create" | "edit";
	state: FormState;
	timeRange: TimeRange;
	// keep the draft of all variables for cases when a variable references another variable
	variables: ReadonlyArray<DashboardVariable>;
	onSave: (variable: DashboardVariable) => void;
}

export interface InitEditDrawerStateParams {
	id?: string;
	variable: DashboardVariable;
	variables: ReadonlyArray<DashboardVariable>;
	timeRange: TimeRange;
	onSave: (variable: DashboardVariable) => void;
}

export function initEditDrawerState({ variable, ...state }: InitEditDrawerStateParams): DrawerState {
	return {
		mode: "edit",
		state: Processor.fromSpec(variable),
		...state,
	};
}

export type InitCreateDrawerStateParams = Omit<InitEditDrawerStateParams, "variable">;

export function initCreateDrawerState(state: InitCreateDrawerStateParams): DrawerState {
	return {
		mode: "create",
		state: Processor.fromSpec(undefined),
		...state,
	};
}
